import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from './http/api.service';

@Injectable({
  providedIn: 'root'
})
export class SalesStructureService {
  constructor(private apiClient: ApiService) {
  }

  getSalesStructures(companyId: number): Observable<any> {
    return this.apiClient.get(`/${companyId}/sales-structures`);
  }

  getSalesStructure(companyId: number, id: number): Observable<any> {
    return this.apiClient.get(`/${companyId}/sales-structures/${id}`);
  }

  createSalesStructure(companyId: number, data): any {
    return this.apiClient.post(`/${companyId}/sales-structures`, data);
  }

  updateSalesStructure(companyId: number, id: number, data): any {
    return this.apiClient.put(`/${companyId}/sales-structures/${id}`, data);
  }

  deleteSalesStructure(companyId: number, id: number): any {
    return this.apiClient.delete(`/${companyId}/sales-structures/${id}`);
  }

  getPosition(companyId: string | number, saleStructureId: string | number, supervisorLevelCode: string) {
    return this.apiClient.get(`/${companyId}/sales-structures/sale-level-by-supervisor/${saleStructureId}/${supervisorLevelCode}`)
  }

  getSaleList(companyId: string | number) {
    return this.apiClient.get(`/${companyId}/salesperson/branch/0`);
  }

  getSaleStructure(companyId: string | number) {
    return this.apiClient.get(`/${companyId}/sales-structure-teams`);
  }
}
